import { isFulfilled, Middleware } from '@reduxjs/toolkit';
import { AuditEntityType } from '@sr/dto';
import { auditApi } from './api';

// The lead editor uses several independent API slices (contacts, comments, cases).
// Refresh audit after the server has committed a successful write from any of them.
export const leadAuditRefreshMiddleware: Middleware = ({ dispatch, getState }) => (next) => (action) => {
  const result = next(action);
  if (!isFulfilled(action)) return result;
  const meta = action.meta as typeof action.meta & {
    arg?: { type?: string };
    baseQueryMeta?: { request?: { url: string; method: string } };
  };
  const request = meta.baseQueryMeta?.request;
  if (meta.arg?.type !== 'mutation' || !request || request.method === 'GET') return result;
  const path = new URL(request.url, 'http://localhost').pathname;
  if (!/\/(?:lead|contacts|events)(?:\/|$)/.test(path)) return result;
  const tags = auditApi.util.selectInvalidatedBy(getState(), ['AuditLog'])
    .filter(({ originalArgs }) => originalArgs?.entityType === AuditEntityType.LEAD)
    .map(({ originalArgs }) => ({ type: 'AuditLog' as const, id: `lead-${originalArgs.entityId}` }));
  if (tags.length) dispatch(auditApi.util.invalidateTags(tags));
  return result;
};
